
import moment from 'moment';
import React, { Component}  from 'react';
import CopyToClipboardButton from 'common/CopyToClipboardButton';


export default class DetailCopyToClipboardButton extends Component {

  getTextForVladivostok = () => {
    const { order } = this.props;
    let text = '';
    if (order.points.length > 0) {
      const point = order.points[0];

      text += `Точка1: ${point.point_display}`;
      if (point.point_address) {
        text += `\nАдрес: ${point.point_address}`;
      }
      if (point.point_text) {
        text += `\nПримечание: ${point.point_text}`;
      }
      if (point.point_contact) {
        text += `\nКонтакты: ${point.point_contact}`;
      }

      if (order.container_number) {
        text += `\nНомер контейнера: ${order.container_number}`;
      }

      if (point.date) {
        text += `\nДата подачи контейнера: ${moment(point.date).format('DD.MM.YYYY HH:mm')}`;
      }

      if (order.container_type_display) {
        text += `\nТипоразмер контейнера: ${order.container_type_display}`;
      }

      if (order.cargo_weight) {
        text += `\nВес груза: ${order.cargo_weight}`;
      }
    }

    order.points.forEach((point, index) => {
      if (index > 0) {
        text += `\n\nТочка ${index + 1}: ${point.point_display}`;
        if (point.point_address) {
          text += `\nАдрес: ${point.point_address}`;
        }
        if (point.point_text) {
          text += `\nПримечание: ${point.point_text}`;
        }
        if (point.point_contact) {
          text += `\nКонтакты: ${point.point_contact}`;
        }
        if (point.date) {
          text += `\nДата подачи контейнера: ${moment(point.date).format('DD.MM.YYYY HH:mm')}`;
        }
      }
    });

    if (order.carrier) {
      text += `\n\nПеревозчик: ${order.carrier_display}`
    }

    return text;
  };

  getTextForMoscow = () => {
    const { order } = this.props;
    let text = '';
    if (order.tractor_unit) {
      text += order.tractor_unit.number;

      if (order.semi_trailer) {
        text += ', ' + order.semi_trailer.number;
      }
      else {
        text += ', без прицепа';
      }
    }
    else {
      text = 'Тягач не указан';
    }

    if (order.driver) {
      text += `\nВодитель: ${order.driver.full_name}`;
    }
    if (order.carrier) {
      text += `\nПеревозчик: ${order.carrier_display}`
    }
    if (order.order_type_display) {
      text += `\nТип перевозки: ${order.order_type_display}`
    }

    if (order.container_number) {
      text += `\nНомер контейнера: ${order.container_number}`;
      if (order.container_type_display) {
        text += ` ${order.container_type_display}`;
      }
    }
    else if (order.container_type_display) {
      text += `\nТип контейнера ${order.container_type_display}`;
    }

    if (order.cargo_weight) {
      text += `\nВес груза: ${order.cargo_weight}`;
    }

    order.points.forEach((point, index) => {
      text += `\n— Точка ${index + 1}: ${point.point_display}`;
      if (point.point_address) {
        text += `\nАдрес: ${point.point_address}`;
      }
      if (point.point_text) {
        text += `\nПримечание: ${point.point_text}`;
      }
      if (point.point_contact) {
        text += `\nКонтакты: ${point.point_contact}`;
      }
      if (point.date) {
        text += `\nДата подачи контейнера: ${moment(point.date).format('DD.MM.YYYY HH:mm')}`;
      }
      if (point.status_display) {
        text += `\nСтатус: ${point.status_display}`;
      }
      if (point.point_text) {
        text += `\nТочка: ${point.point_text}`;
      }
    });

    return text;
  }

  render() {
    const { order } = this.props;
    const text = order.department === 1 ? this.getTextForVladivostok() : this.getTextForMoscow();
    return (
      <CopyToClipboardButton
        variant={'outlined'}
        text={text}
        label={'Скопировать задание'}
        size={'small'}
      />
    )
  }
}